module.exports = __webpack_public_path__ + "img/conveyor.c64be13f.svg";